import React from 'react';

interface ProgressBarProps {
  /** Expects a float between 0 and 1 */
  progress: number;
  /** Expect a tailwind bg- */
  progressColor?: string;
}

export default function ProgressBar({ progress, progressColor = 'bg-success-500' }: ProgressBarProps) {
  if (progress < 0) progress = 0;
  if (progress > 1) progress = 1;

  const progressRounding = progress === 1 ? 'rounded-[100px]' : 'rounded-l-[100px]';
  const missing = 1 - progress;
  const emptyRounding = missing === 1 ? 'rounded-[100px]' : 'rounded-r-[100px]';

  return (
    <div className='flex h-2 w-full rounded-[100px]'>
      <div style={{ width: progress * 100 + '%' }} className={`h-2 ${progressColor} ${progressRounding}`}></div>
      <div style={{ width: 100 - progress * 100 + '%' }} className={`h-2 bg-gray-300 ${emptyRounding}`}></div>
    </div>
  );
}
